var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.49692e-07 7.49996C-3.62296e-07 7.24364 0.12448 6.99979 0.341495 6.831L8.3415 0.608781C8.75713 0.285508 9.3889 0.322946 9.75258 0.692401C10.1163 1.06186 10.0741 1.62342 9.6585 1.9467L2.51859 7.49996L9.65851 13.0532C10.0741 13.3765 10.1163 13.9381 9.75258 14.3075C9.3889 14.677 8.75713 14.7144 8.3415 14.3911L0.341495 8.16892C0.12448 8.00013 -3.37087e-07 7.75628 -3.49692e-07 7.49996Z",
    fill: "#0063C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.b8cd184f8d26b1a7096eaeac81ffd17b.svg";
export { ForwardRef as ReactComponent };